/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityFindingsAggResult } from './MonitEntityFindingsAggResult';
import {
    MonitEntityFindingsAggResultFromJSON,
    MonitEntityFindingsAggResultFromJSONTyped,
    MonitEntityFindingsAggResultToJSON,
} from './MonitEntityFindingsAggResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityFindingsAggResponse
 */
export interface MonitPaginatedEntityFindingsAggResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityFindingsAggResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityFindingsAggResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityFindingsAggResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityFindingsAggResult>}
     * @memberof MonitPaginatedEntityFindingsAggResponse
     */
    results?: Array<MonitEntityFindingsAggResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityFindingsAggResponse interface.
 */
export function instanceOfMonitPaginatedEntityFindingsAggResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityFindingsAggResponseFromJSON(json: any): MonitPaginatedEntityFindingsAggResponse {
    return MonitPaginatedEntityFindingsAggResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityFindingsAggResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityFindingsAggResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityFindingsAggResultFromJSON)),
    };
}

export function MonitPaginatedEntityFindingsAggResponseToJSON(value?: MonitPaginatedEntityFindingsAggResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityFindingsAggResultToJSON)),
    };
}

